import { addStyles } from 'ethcss'
import { IStyles } from 'theme'
import { textSizes } from 'theme/media'

export const styles: IStyles = {
    page: {
        position: 'relative',
        width: `100%`,
        height: `100%`,
        fontSize: textSizes.normal,
        minHeight: '100%',
    },
    page__userWindow: {
        top: 0,
    },
}

addStyles(styles)
